import { clientHttp } from '@/shared/api/client'
import { CLIENT_API_ENDPOINTS } from '@/shared/lib'

import {
  type ICarStoryHomeResponse,
  type IGetMycleContentCategoriesParams,
  type IGetMycleContentsBySeriesParams,
  type IGetMycleContentsParams,
  type IMycleContentCategory,
  type IMycleContentLikeResponse,
  type IPageMycleContentResponse,
  type IPageMycleContentSeriesResponse,
} from '../../model/home'
import {
  type IGetNearestPlacesParams,
  type INearestPlaceWithReview,
} from '../../model/nearestPlace'

export const getCarStoryHome = async (): Promise<ICarStoryHomeResponse> => {
  return await clientHttp.get(CLIENT_API_ENDPOINTS.CAR_STORY.HOME)
}

export const getMycleContents = async ({
  menu,
  page = 0,
  size = 20,
  sort,
  categoryId,
}: IGetMycleContentsParams): Promise<IPageMycleContentResponse> => {
  return await clientHttp.get(
    CLIENT_API_ENDPOINTS.CAR_STORY.CONTENTS({
      menu,
      page,
      size,
      sort,
      categoryId,
    })
  )
}

export const getMycleContentCategories = async ({
  menu,
}: IGetMycleContentCategoriesParams): Promise<IMycleContentCategory[]> => {
  return await clientHttp.get(
    CLIENT_API_ENDPOINTS.CAR_STORY.CATEGORIES({ menu })
  )
}

export const getMycleContentsBySeries = async ({
  code,
  page = 0,
  size = 20,
}: IGetMycleContentsBySeriesParams): Promise<IPageMycleContentSeriesResponse> => {
  return await clientHttp.get(
    CLIENT_API_ENDPOINTS.CAR_STORY.SERIES({ code, page, size })
  )
}

export const likeMycleContent = async (
  contentId: number
): Promise<IMycleContentLikeResponse> => {
  return await clientHttp.put(CLIENT_API_ENDPOINTS.CAR_STORY.LIKE(contentId))
}

export const unlikeMycleContent = async (
  contentId: number
): Promise<IMycleContentLikeResponse> => {
  return await clientHttp.put(CLIENT_API_ENDPOINTS.CAR_STORY.UNLIKE(contentId))
}

export const getCarStoryNearestPlaces = async ({
  latitude,
  longitude,
}: IGetNearestPlacesParams): Promise<INearestPlaceWithReview[]> => {
  return await clientHttp.get(
    CLIENT_API_ENDPOINTS.CAR_STORY.NEAREST_PLACES({ latitude, longitude })
  )
}
